module.exports = __webpack_public_path__ + "img/art-ron-1.78d1aed0.jpg";